import React from 'react'

import PackageUpgradeModal from './PackageUpgradeModal'
import Breakpoint from 'components/Common/Breakpoint'

interface Props {
  isOpen: boolean;
  onNoThanks: () => void;
  onClose: () => void;
  onUpgrade: () => void;
  children: React.ReactNode;
}

function PackageUpgradePopup(props: Props) {
  const { children, ...sharedProps } = props
  return (
    <>
      <Breakpoint max="sm">
        <PackageUpgradeModal {...sharedProps}>
          {children}
        </PackageUpgradeModal>
      </Breakpoint>
      <Breakpoint min="md">
        <PackageUpgradeModal {...sharedProps} desktop>
          {children}
        </PackageUpgradeModal>
      </Breakpoint>
    </>
  )
}

export default PackageUpgradePopup
